import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';

export default function RestoreConfirmationModal({ open, onClose, onConfirm, item, itemType }) {
  const [dependencies, setDependencies] = useState([]);
  const [selectedToRestore, setSelectedToRestore] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open && item && itemType) {
      const controller = new AbortController();

      const fetchDependencies = async () => {
        setLoading(true);
        try {
          setSelectedToRestore({}); // Limpa seleção anterior
          const endpoint = itemType === 'company' ? 'companies' : 'users';
          const identifier = itemType === 'company' ? item.slug : item.userName;
          const res = await api.get(`/${endpoint}/${identifier}/dependencies`, {
            signal: controller.signal,
          });
          const foundDependencies = [];

          if (res.data.users?.length > 0) {
            foundDependencies.push({
              type: 'users',
              label: 'Usuários na Lixeira',
              items: res.data.users,
            });
            // Por padrão, seleciona todos os usuários para restauração
            setSelectedToRestore({ users: res.data.users.map(u => u.id) });
          }

          setDependencies(foundDependencies);
        } catch (error) {
          if (error.name === 'CanceledError') {
            console.log('Busca de dependências cancelada.');
            return;
          }
          console.error('Erro ao buscar dependências:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchDependencies();

      controller.abort();
      return;
    }
  }, [open, item, itemType]);

  if (!open) return null;

  const handleToggleSelection = (type, id) => {
    setSelectedToRestore(prev => {
      const currentSelection = prev[type] || [];
      if (currentSelection.includes(id)) {
        return { ...prev, [type]: currentSelection.filter(itemId => itemId !== id) };
      }
      return { ...prev, [type]: [...currentSelection, id] };
    });
  };

  const handleToggleAll = (type, items) => {
    setSelectedToRestore(prev => {
      const allIds = items.map(i => i.id);
      const allSelected = (prev[type] || []).length === allIds.length;
      return { ...prev, [type]: allSelected ? [] : allIds };
    });
  };

  const itemName = item?.name || item?.fullName || item?.slug;
  const typeName = itemType === 'company' ? 'Empresa' : 'Usuário';

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div
        className="edit-modal card"
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '500px' }}
      >
        <div className="card-body">
          <div className="modal-header">
            <h3>Restaurar {typeName}</h3>
            <button onClick={onClose} className="btn btn-secondary">
              ✕
            </button>
          </div>

          <div className="modal-content">
            {loading ? (
              <div className="loading-state">Verificando itens vinculados...</div>
            ) : (
              <>
                <p>
                  O item <strong>{itemName}</strong> será restaurado. Selecione os itens abaixo que
                  devem ser restaurados junto com ele.
                </p>
                <div className="dependencies-list">
                  {dependencies.map(dep => (
                    <div className="dependency-group" key={dep.type}>
                      <div className="dependency-header">
                        <input
                          type="checkbox"
                          id={`select-all-${dep.type}`}
                          checked={
                            (selectedToRestore[dep.type] || []).length === dep.items.length &&
                            dep.items.length > 0
                          }
                          onChange={() => handleToggleAll(dep.type, dep.items)}
                        />
                        <label htmlFor={`select-all-${dep.type}`}>
                          <strong>
                            {dep.label} ({dep.items.length})
                          </strong>
                        </label>
                      </div>
                      <ul className="dependency-items">
                        {dep.items.map(depItem => (
                          <li key={depItem.id}>
                            <input
                              type="checkbox"
                              id={`${dep.type}-${depItem.id}`}
                              checked={(selectedToRestore[dep.type] || []).includes(depItem.id)}
                              onChange={() => handleToggleSelection(dep.type, depItem.id)}
                            />
                            <label htmlFor={`${dep.type}-${depItem.id}`}>{depItem.fullName}</label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn btn-secondary">
              Cancelar
            </button>
            <button
              type="button"
              onClick={() => onConfirm(item, selectedToRestore)}
              className="btn btn-primary"
              disabled={loading}
            >
              Confirmar Restauração
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
